import React from 'react'
import { Announce } from './main-page/Announce'

export const Announcement = () => {
  return (
    <div>
<Announce/>

    </div>
  )
}
